// // Signup.js
// import React, { useState } from 'react';
// import { FiMail, FiLock, FiArrowLeft, FiEye, FiEyeOff, FiPhone } from 'react-icons/fi';
// // import logo from './Assets/graduation-cap.jpg';
// import logo from '/SOFTWARE/reactApp/Sayali-React/exam-app/src/Assets/graduation-cap.jpg';
// import { useNavigate } from 'react-router-dom'; // optional for navigation
// import './Signup.css';

// function Signup() {
//     const navigate = useNavigate(); // Optional: only if using React Router

//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [confirmPassword, setConfirmPassword] = useState('');
//     const [error, setError] = useState('');
//     const [showPassword, setShowPassword] = useState(false);
//     const [showConfirmPassword, setShowConfirmPassword] = useState(false);


//     const handleSignup = (e) => {
//         e.preventDefault();

//         // Basic validation
//         if (!email || !password || !confirmPassword) {
//             setError('All fields are required');
//             return;
//         }

//         if (password !== confirmPassword) {
//             setError('Passwords do not match');
//             return;
//         }

//         setError('');
//         alert('Account created successfully!');
//         // Submit to API or redirect
//     };

//     return (
//         <div className="signup-container">
//             <div className="signup-box">

//                 {/* <div className="back-to-login" onClick={() => navigate('/login')}>
//                     <FiArrowLeft className="back-icon" />
//                     <span>Back to Login</span>
//                 </div> */}

//                 {/* <h2>Sign Up</h2> */}
//                 <div className='signup-header'>
//                     {/* <div className="back-link" onClick={() => navigate('/login')}>
//                         <FiArrowLeft className="back-icon" />
//                         <span>Back to Login</span>
//                     </div> */}

//                     <img src={logo} alt="logo" className="signup-image" />

//                     <h2 className="signup-title slide-in-text">Sign Up</h2>

//                 </div>
//                 <form onSubmit={handleSignup}>
//                     <div className="input-group">
//                         <FiPhone className="icon" />
//                         <input type="tel" placeholder="Mobile Number" required />
//                     </div>

//                     <div className="input-group">
//                         <FiLock className="icon" />
//                         <input
//                             type={showPassword ? 'text' : 'password'}
//                             placeholder="Password"
//                             value={password}
//                             onChange={(e) => setPassword(e.target.value)}
//                             required
//                         />
//                         <span
//                             className="toggle-icon"
//                             onClick={() => setShowPassword(!showPassword)}
//                         >
//                             {showPassword ? <FiEyeOff /> : <FiEye />}
//                         </span>
//                     </div>

//                     <div className="input-group">
//                         <FiLock className="icon" />
//                         <input
//                             type={showConfirmPassword ? 'text' : 'password'}
//                             placeholder="Confirm Password"
//                             value={confirmPassword}
//                             onChange={(e) => setConfirmPassword(e.target.value)}
//                             required
//                         />
//                         <span
//                             className="toggle-icon"
//                             onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                         >
//                             {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
//                         </span>
//                     </div>

//                     {error && <p className="error-text">{error}</p>}

//                     <button type="submit">Sign Up</button>

//                     <div className="login-link-bottom">
//                         <p>
//                             <span onClick={() => navigate('/login')} className="back-login-text">
//                                 Back to Login
//                             </span>
//                         </p>
//                     </div>

//                 </form>
//             </div>
//         </div>
//     );
// }

// export default Signup;




import React, { useState } from 'react';
import { FiLock, FiEye, FiEyeOff, FiPhone, FiUser, FiMail } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Player } from '@lottiefiles/react-lottie-player';
import { useNavigate } from 'react-router-dom';
// import signupAnimation from './Signup.css';
// import './signup-animation.json';
import studentImage from '../../Assets/SignUpImage.png'; // or any signup illustration


function Signup() {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);


        const validateForm = () => {
        if (!name || !email || !mobile || !password || !confirmPassword) {
            setError('All fields are required!');
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Please enter a valid email address.');
            return false;
        }

        if (!/^\d{10}$/.test(mobile)) {
            setError('Mobile number must be 10 digits.');
            return false;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match!');
            return false;
        }

        setError('');
        return true;
    };

   const handleSignup = async (e) => {
  e.preventDefault();

  if (!validateForm()) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: error });
            return;
        }
  setLoading(true);

  try {
    // Show loading SweetAlert
    Swal.fire({
      title: 'Creating Account...',
      html: 'Please wait while we create your account.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const response = await fetch('http://192.168.101.200:8000/api/users', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name,
        email,
        phone: mobile,
        password,
        usertype: 'user',
        status: true,
      }),
    });

    const data = await response.json();

    if (!response.ok) throw new Error(data.message || 'Signup failed');

    Swal.close(); // close loading popup

    // Success SweetAlert
    await Swal.fire({
      icon: 'success',
      title: 'Account Created!',
      text: 'Your account has been created successfully.',
      confirmButtonText: 'Login'
    });

     // Reset form
            setName('');
            setEmail('');
            setMobile('');
            setPassword('');
            setConfirmPassword('');

            navigate('/'); // redirect to login
        } catch (err) {
            Swal.close();
            Swal.fire({ icon: 'error', title: 'Signup Failed', text: err.message });
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="login-container">
            {/* Left animation */}
            <motion.div
                className="login-left"
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1 }}
            >
                <Player
                    autoplay
                    loop
                    //src={signupAnimation}
                    src="https://assets2.lottiefiles.com/packages/lf20_touohxv0.json"
                    //src="https://assets2.lottiefiles.com/packages/lf20_5cbGMAtYv2.json"
                    style={{ height: '100%', width: '100%', maxWidth: '400px' }}
                />
            </motion.div>

            {/* Right form */}
            <motion.div
                className="login-right"
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1 }}
            >
                <div className="login-box">
                    {/* Header */}
                    <div className="login-header">
                        <img
                            src={studentImage}
                            alt="Student Illustration"
                            className="student-image avatar-floating"
                        />
                        <h1 className="hello-text">Hello!</h1>
                        <h2 className="welcome-heading">
                            <span className="wave-emoji">👋</span> Create Account
                        </h2>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSignup}>
                        <motion.div
                            className="input-group"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.4, delay: 0.1 }}
                        >
                            <FiUser className="icon" />
                            <input
                                type="text"
                                placeholder="Full Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </motion.div>
                        <motion.div
                            className="input-group"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.4, delay: 0.15 }}
                        >
                            <FiMail className="icon" />
                            <input
                                type="email"
                                placeholder="Email Address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </motion.div>
                        <motion.div
                            className="input-group"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.4, delay: 0.2 }}
                        >
                            <FiPhone className="icon" />
                            <input
                                type="tel"
                                placeholder="Mobile Number"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                required
                            />
                        </motion.div>

                        <motion.div
                            className="input-group"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.4, delay: 0.3 }}
                        >
                            <FiLock className="icon" />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <div
                                className="toggle-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </div>
                        </motion.div>

                        <motion.div
                            className="input-group"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.4, delay: 0.4 }}
                        >
                            <FiLock className="icon" />
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            <div
                                className="toggle-icon"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                            </div>
                        </motion.div>

                        {error && <p className="error-text">{error}</p>}

                        <button type="submit" disabled={loading}>
                            {loading ? 'Creating Account...' : 'Sign Up'}
                        </button>

                        <div className="signup-link">
                            {/* <p>
                                Already have an account? 
                                <span onClick={() => navigate('/login')} className="back-login-text">Login</span>
                            </p> */}

                            <p>
                                Already have an account?{' '}
                                <Link to="/" className="back-login-text">Login</Link>
                            </p>
                        </div>
                    </form>
                </div>
            </motion.div>
        </div>
    );
}

export default Signup;
